import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import FormContainer from "../components/FormContainer";
import RegisterCustomerForm from "../components/RegisterCustomerForm";
import StepsHeader from "../components/StepsHeader";
import { AppState } from "../redux/types";
import { localePath } from "../i18n/config";
import { categoryOptions } from "../utils/constants";

const Register = () => {
    const user = useSelector((state: AppState) => state.user);
    const category = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const history = useHistory();

    const goto = () => {
        if (category === categoryOptions.app) {
            history.push(localePath("tili", "seniori"));
        } else {
            history.push(localePath("toimitus"));
        }
    };

    return (
        <>
            <StepsHeader step1 step2 user={1} payment={1} account={1} />
            <FormContainer>
                {user.isLoggedIn ? (
                    <div>
                        <div>You are already registered. Go to the next step</div>
                        <Button className="register-button tallenna" onClick={goto}>
                            Yhteystiedot, toimitus
                        </Button>
                    </div>
                ) : (
                    <RegisterCustomerForm />
                )}
            </FormContainer>
        </>
    );
};

export default Register;
